import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

import dotenv from "dotenv";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

dotenv.config();

// const firebaseConfig = {
//   apiKey: "AIzaSyBidrNnhjV9b6yOJ3s7F0_XKgCq8bE0Rww",
//   authDomain: "vbts-edit-form.firebaseapp.com",
//   projectId: "vbts-edit-form",
//   storageBucket: "vbts-edit-form.appspot.com",
//   databaseURL: "https://vbts-edit-form-default-rtdb.firebaseio.com",
//   messagingSenderId: "633405705112",
//   appId: "1:633405705112:web:42eef21afd189b6f38b9ed",
//   measurementId: "G-MLHYH8HJQZ",
// };


  const firebaseConfig = {
    apiKey: "AIzaSyC8QD1mZoC5lVg0cMEFYuI4HvcRpxx6sEA",
    authDomain: "vbts-grade.firebaseapp.com",
    databaseURL: "https://vbts-grade-default-rtdb.firebaseio.com",
    projectId: "vbts-grade",
    storageBucket: "vbts-grade.appspot.com",
    messagingSenderId: "574478077602",
    appId: "1:574478077602:web:e6801a5aedd5af6551d1fb",
    measurementId: "G-WFKNG4N50D",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider(); //for google signin
export const storage = getStorage(app);
export const database = getDatabase(app);

// export const DATABASE_REFERENCE_1 = "/vbts-form/form1-edit/form-main";
// export const DATABASE_REFERENCE_2 = "/vbts-form/form1-edit/form-subpart-A";
// export const DATABASE_REFERENCE_3 = "/vbts-form/form1-edit/form-subpart-B";

export const DATABASE_REFERENCE_1 = "/vbts/student-grade-gpa/student";
export const DATABASE_REFERENCE_2 = "/vbts/student-grade-gpa/grade-entry";
export const DATABASE_REFERENCE_3 = "/vbts/student-grade-gpa/gpa";
